import React, { useEffect } from 'react'
import $ from 'jquery'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/course.css'

export default function CourseContent() {
  useEffect(() => {
    const tabsNavAnchors = document.querySelectorAll('.about_course_page .tabs_nav a');

    tabsNavAnchors.forEach((tabsNavAnchor) => {
      tabsNavAnchor.addEventListener('click', () => {
        $('.about_course_page .tabs_nav a.active').removeClass('active');
        tabsNavAnchor.classList.add('active');
      });
    });

    
    if(window.location.hash === "#overview"){
      scrollTop()
    }
  }, [])

  function scrollTop(){
    window.scrollTo(0, 0)
  }
  return (
    <div className="course_content_page pd_enabled course_page page_body">
      <PageTransition />
      <div className="container">
        <div className="wrapper">
          <div className="left">
            <div className="course_content select_n">
              <video controls>
                <source src="https://www.youtube.com/embed/C72WkcUZvco" type="video/mp4" />
              </video>
            </div>

            <nav className='tabs_nav select_n'>
              <a href={window.location.pathname+"#overview"} className="active" onClick={scrollTop}>Overview</a>
              <a href={window.location.pathname+"#mentor"}>Mentor</a>
              <a href={window.location.pathname+"#description"}>Description</a>
              <a href={window.location.pathname+"#contents"}>Contents</a>
              <a href={window.location.pathname+"#reviews"}>Reviews</a>
            </nav>

            <section id="mentor">
              <h2>Overview</h2>
            </section>
            <section id="description">
              <h2>Overview</h2>
            </section>
            <section id="contents">
              <h2>Overview</h2>
            </section>
          </div>
          <div className="right" id="overview">
            ssss
          </div>
        </div>
      </div>
    </div>
  )
}
